import React from 'react';
import styled from 'styled-components';
import { Draggable } from 'react-beautiful-dnd';
import { Field, useField, useForm } from 'react-final-form';

import { numberToCurrency } from 'vqp-common';
import { IconButton, Icon, Checkbox } from '../../common';
import { isRequired } from '../../../utils/validations';
import { TextInputWithLabel } from './TextInputWithLabel';

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  padding-bottom: 30px;
  padding-top: 10px;
  background-color: rgb(255, 255, 255);
  ${(props) =>
    props.index % 2 === 0 &&
    `
        background-color: rgba(0,0,0,0.03)
    `}
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr 3fr 1fr;
  grid-template-areas:
    'code name name delete'
    '. price deliveryPrice .'
    'description description description .';
  grid-gap: 10px;
  justify-content: center;
  align-items: center;
`;

const GridArea = styled.div`
  grid-area: ${(props) => props.area};
  padding: 0 15px;
`;

const CounterPriceWrapper = styled.div`
  display: flex;
  flex-direction: row;
`;

const CheckboxWrapper = styled.div`
  font-size: 10px;
  padding-left: 3px;
`;

export const DetailItem = ({ field, index, item = {}, onDelete }) => {
  const form = useForm();

  const { code, name, price, deliveryPrice, description } = item;

  const priceField = useField(`${field}.price`, {
    initialValue: numberToCurrency(price),
    validate: isRequired
  });

  const deliveryPriceField = useField(`${field}.deliveryPrice`, {
    initialValue: numberToCurrency(deliveryPrice),
    validate: isRequired
  });

  const deliveryPriceEqualsField = useField(`${field}.deliveryPriceEquals`, {
    initialValue:
      priceField.input.value &&
      deliveryPriceField.input.value &&
      priceField.input.value === deliveryPriceField.input.value
  });

  console.log(deliveryPriceField);
  return (
    <Draggable
      type="detailItem"
      key={`detailItem${code}${index}`}
      draggableId={`detailItem${code}${index}`}
      index={index}
    >
      {(provided, snapshot) => (
        <Wrapper
          index={index}
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
        >
          <Icon name="drag" />
          <Grid>
            <GridArea area="code">
              <Field
                name={`${field}.code`}
                initialValue={code}
                validate={isRequired}
              >
                {({ input, meta }) => {
                  const error = meta.touched && meta.error;
                  return (
                    <TextInputWithLabel
                      error={error}
                      label="Código"
                      {...input}
                    />
                  );
                }}
              </Field>
            </GridArea>
            <GridArea area="name">
              <Field
                name={`${field}.name`}
                initialValue={name}
                validate={isRequired}
              >
                {({ input, meta }) => {
                  const error = meta.touched && meta.error;
                  return (
                    <TextInputWithLabel
                      error={error}
                      label="Nome do item"
                      {...input}
                    />
                  );
                }}
              </Field>
            </GridArea>
            <GridArea area="price">
              {/*<TextInputWithLabel
                error={priceField.meta.touched && priceField.meta.error}
                label="Valor balcão"
                isCurrency
                {...priceField.input}
              />*/}
              <Field
                name={`${field}.price`}
                initialValue={priceField.input.value}
                validate={isRequired}
              >
                {({ input, meta }) => {
                  const error = meta.touched && meta.error;
                  return (
                    <TextInputWithLabel
                      error={error}
                      label="Valor balcão"
                      isCurrency
                      {...input}
                    />
                  );
                }}
              </Field>
            </GridArea>
            <GridArea area="deliveryPrice">
              <CounterPriceWrapper>
                {deliveryPriceEqualsField.input.value === true ? (
                  <TextInputWithLabel
                    label="Valor delivery"
                    disabled={true}
                    isCurrency
                    {...priceField.input}
                  />
                ) : (
                  <Field
                    name={`${field}.deliveryPrice`}
                    initialValue={deliveryPriceField.input.value}
                    validate={isRequired}
                  >
                    {({ input, meta }) => {
                      const error = meta.touched && meta.error;
                      return (
                        <TextInputWithLabel
                          error={error}
                          label="Valor delivery"
                          isCurrency
                          {...input}
                        />
                      );
                    }}
                  </Field>
                )}

                <CheckboxWrapper>
                  <Checkbox
                    checked={deliveryPriceEqualsField.input.value}
                    onCheck={deliveryPriceEqualsField.input.onChange}
                  >
                    Igualar balcão?
                  </Checkbox>
                </CheckboxWrapper>
              </CounterPriceWrapper>
            </GridArea>
            <GridArea area="delete">
              <IconButton
                icon="delete"
                onClick={onDelete}
                title={`Excluir`}
              />
            </GridArea>
            <GridArea area="description">
              <Field
                name={`${field}.description`}
                initialValue={description}
              >
                {({ input, meta }) => {
                  const error = meta.touched && meta.error;
                  return (
                    <TextInputWithLabel
                      error={error}
                      label="Descrição"
                      {...input}
                    />
                  );
                }}
              </Field>
            </GridArea>
          </Grid>
        </Wrapper>
      )}
    </Draggable>
  );
};
